module.exports = "/assets/data/c527304d486c84e0ec993628b22b145a-GL14.data.json";